module.exports = __webpack_public_path__ + "img/07.d6c83e29.png";